import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o'; 


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent {
  // Gallery Properties
  currentGalleryIndex = 0;
  showGalleryModal = false;

  // About Gallery Properties
  currentAboutGalleryIndex = 0;
  showAboutGalleryModal = false;

  // About Gallery Items
  aboutGalleryItems = [
    {
      src: 'assets/images/about/about-img-3.jpg',
      title: 'Gallery Image 1'
    },
    {
      src: 'assets/images/about/about-img-4.jpg',
      title: 'Gallery Image 2'
    }
  ];

  // About Gallery Methods
  openAboutGallery(index: number): void {
    this.currentAboutGalleryIndex = index;
    this.showAboutGalleryModal = true;
  }

  closeAboutGallery(): void {
    this.showAboutGalleryModal = false;
  }

  nextAboutGalleryImage(): void {
    if (this.currentAboutGalleryIndex < this.aboutGalleryItems.length - 1) {
      this.currentAboutGalleryIndex++;
    } else {
      this.currentAboutGalleryIndex = 0;
    }
  }

  previousAboutGalleryImage(): void {
    if (this.currentAboutGalleryIndex > 0) {
      this.currentAboutGalleryIndex--;
    } else {
      this.currentAboutGalleryIndex = this.aboutGalleryItems.length - 1;
    }
  }

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Pricing Plans
  pricingPlans = [
    {
      id: 1,
      name: 'Basic Plan',
      price: '$29.99',
      features: [
        'Up to 5 Projects',
        '5GB Storage',
        'Basic Support',
        'Monthly Updates',
        'Community Access'
      ]
    },
    {
      id: 2,
      name: 'Professional',
      price: '$79.99',
      features: [
        'Unlimited Projects',
        '500GB Storage',
        'Priority Support',
        'Weekly Updates',
        'Advanced Analytics',
        'Team Collaboration'
      ]
    },
    {
      id: 3,
      name: 'Enterprise',
      price: '$199.99',
      features: [
        'Custom Solutions',
        'Unlimited Storage',
        '24/7 Support',
        'Real-time Updates',
        'Advanced Analytics',
        'Custom Integration',
        'Dedicated Account Manager'
      ]
    }
  ];

  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: "Anny Adams",
      subtitle: "CEO/Founder",
      image: "client-1-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "Bryan Matt",
      subtitle: "Developer",
      image: "client-2-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "David Marks",
      subtitle: "Designer",
      image: "client-3-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }

  ];
}
